import { render, staticRenderFns } from "./SgLogo.vue?vue&type=template&id=c515a07e&"
import script from "./SgLogo.vue?vue&type=script&lang=js&"
export * from "./SgLogo.vue?vue&type=script&lang=js&"
import style0 from "./SgLogo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports